<template>
   <div class="library_item_wrapper">
       <div class="library_item">
           <div class="library_item-title">{{data.name}}</div>
           <div class="library_item_top">
               <div class="library_item_top_date">
                   <img src="@/assets/svg/calendar.svg">
                   <span>{{data.date}}</span>
               </div>
               <div class="library_item_top_button">
                   <span>Open in gallery</span>
                   <img src="@/assets/svg/arrow.svg">
               </div>
           </div>
           <div class="library_item-text">
               <p>
                   {{data.description}}
               </p>
           </div>
           <div v-if="flag" class="library_item_files">
               <carousel class="library_item_files_carousel" :responsive="{0:{items:1, nav:false, dots:false},720:{items:3, nav:false, dots:false}}">
                   <template v-for="doc in docs" >
                       <div class="library_item_files_block" v-on:click="getDoc(doc.item.id, doc.item)" :key="doc.item.id">
                           <img  v-if="doc.type==='pdf'" src="@/assets/svg/pdf.svg">
                           <img  v-if="doc.type==='doc'" src="@/assets/svg/doc.svg">
                           <img  v-if="doc.type==='xls'" src="@/assets/svg/xlsx.svg">
                           <span>{{doc.item.name}}</span>
                           <img src="@/assets/svg/caret-down.svg">
                       </div>
                   </template>
               </carousel>
           </div>
       </div>
   </div>
</template>
<script>
    import DocumentLibraryServices from "../../services/DocumentLibraryServices";
    import carousel from 'vue-owl-carousel'
    export default {
        components: {
            carousel,
        },
        props: {
            data: Object
        },
        data(){
            return {
                docs: [],
                flag: false
            }
        },
        created(){
          setTimeout(()=>{
              this.flag=true
          }, 500)
        },
        mounted() {
            this.$props.data.documents.forEach((item)=>{
                switch (item.type) {
                    case 'doc': this.docs.push({type: 'doc', item: item});break;
                    case 'pdf': this.docs.push({type: 'pdf', item: item});break;
                    case 'xlsx': this.docs.push({type: 'xls', item: item});break;
                }
            })
        },
        methods: {
            async getDoc(id, doc){
                try{
                    const responce = await DocumentLibraryServices.getDocument(id);
                        const url = responce.data.data;
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', doc.name+'.'+doc.type) //or any other extension
                        document.body.appendChild(link)
                        link.click()
                }
                catch (e) {
                    return e;
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    .library_item {
        &_wrapper {
            width: 100%;
        }
        max-width: 1180px;
        width: 98%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: start;
        margin: 0 auto;
        &-title {
            color: #38383a;
            font-family: "Optimal C";
            font-size: 18px;
            font-weight: 400;
            letter-spacing: 0.04px;
            margin-top: 33px;
            margin-bottom: 31px;
        }
        &_top {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 26px;
            &_date {
                display: flex;
                flex-direction: row;
                align-items: center;
                img {
                    width: 15px;
                    height: 16px;
                    margin-right: 14px;
                }
                span {
                    color: #adadad;
                    font-family: "Open Sans - Semi Bold";
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0.3px;
                }
            }
            &_button {
                margin-left: auto;
                display: flex;
                flex-direction: row;
                align-items: center;
                span {
                    color: #2a9854;
                    font-family: "Open Sans";
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0.3px;
                    cursor: pointer;
                    margin-right: 15px;
                    white-space: nowrap;
                }
                img {
                    width: 19px;
                    height: 14px;
                    cursor: pointer;
                }
            }
        }
        &-text {
            width: 97%;

            p {
                max-width: 100%;
                color: #626266;
                font-family: "Open Sans";
                font-size: 14px;
                font-weight: 400;
                line-height: 24px;
                letter-spacing: 0.35px;
                white-space: normal;
            }

            margin-bottom: 55px;
        }
        &_files {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            &_carousel {
                width: 98%;
                overflow-x: hidden;
            }
            @media screen and (max-width: 720px) {
                flex-direction: column;
                align-items: flex-start;
            }
            &_block {
                width: 300px;
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-bottom: 43px;
                span {
                    color: #818181;
                    font-family: "Open Sans";
                    font-size: 12px;
                    font-weight: 400;
                    text-decoration: underline;
                    letter-spacing: 0.3px;
                    margin-left: 18px;
                    margin-right: 17px;
                    cursor: pointer;
                    white-space: nowrap;
                }
                img {
                    width: 14px;
                    height: 7px;
                    cursor: pointer;
                    &:first-child {
                        width: 21px;
                        height: 24px;
                    }
                }
            }
        }
    }

</style>
